import React from 'react'

const NoteListIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13V11.2292L12.4167 6.8125L14.1875 8.58333L9.77083 13H8ZM0.5 8.83333V7.16667H6.33333V8.83333H0.5ZM14.7708 8L13 6.22917L13.6042 5.625C13.7569 5.47222 13.9514 5.39583 14.1875 5.39583C14.4236 5.39583 14.6181 5.47222 14.7708 5.625L15.375 6.22917C15.5278 6.38194 15.6042 6.57639 15.6042 6.8125C15.6042 7.04861 15.5278 7.24305 15.375 7.39583L14.7708 8ZM0.5 5.5V3.83333H9.66667V5.5H0.5ZM0.5 2.16667V0.5H9.66667V2.16667H0.5Z"
        fill="#CCCFD6"
      />
    </svg>
  )
}

export default NoteListIcon
